import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';
import { fillTabContentInEssentialScreenEpic } from 'state/workspaces/essential/tab-content/fill-tab-content-epic';
import { fillTabContentInEssentialScreenFailedEpic } from 'state/workspaces/essential/tab-content/fill-tab-content-failed-epic';

export const essentialScreenTabContentEpic = () =>
  withAppCrashIfException(
    'essentialScreenTabContent',
    combineEpics(
      fillTabContentInEssentialScreenEpic(), // no async, should be a thunk
      fillTabContentInEssentialScreenFailedEpic(), // no async, should be a thunk
    ),
  );
